/* stylelint-disable */
import { css, SerializedStyles } from '@emotion/react';
import { EmotionTheme } from 'src/domains/layouts/state/environmentState/EnvironmentState';

export const cookieBotWidget = (theme: EmotionTheme): SerializedStyles => css`
    /* MAIN WRAPPER */
    #CybotCookiebotDialog[data-template=popup] {
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        height: min-content;
        max-width: 800px !important;
        border-radius: ${theme.star.cookieBot.radius} !important;
    }

    #CookiebotWidget {
        display: none !important;
    }

    /* NAVIGATION */
    .CybotCookiebotDialogNavItem {
        position: relative !important;
    }

    #CybotCookiebotDialogNav {
        border-bottom: unset !important;
        position: relative !important;
    }

    #CybotCookiebotDialogNav::before {
        content: '';
        position: absolute;
        bottom: 1px;
        width: 100%;
        left: 0;
        height: 1px;
        background-color: #D6D6D6;
    }

    #CybotCookiebotDialogNav .CybotCookiebotDialogNavItemLink { 
        font-size: 14px !important;
        padding-top: 30px !important;
    }

    #CybotCookiebotDialogNav .CybotCookiebotDialogNavItemLink.CybotCookiebotDialogActive {
        color: ${theme.star.cookieBot.txtColoTertiary} !important;
        border-bottom: unset !important;
    }
    #CybotCookiebotDialogNav .CybotCookiebotDialogNavItemLink.CybotCookiebotDialogActive::before { 
        content: '' !important;
        position: absolute !important;
        bottom: 0;
        width: 100%;
        left: 0;
        height: 2px;
        background-color: ${theme.star.cookieBot.txtColoTertiary} !important;
    }

    #CybotCookiebotDialogBodyButtonsWrapper {
        flex-direction: column !important;
        gap: 8px !important;
        @media(min-width: 1024px){
            flex-direction: row !important;
            justify-content: space-between !important;
        }
    }

    #CybotCookiebotDialogFooter #CybotCookiebotDialogBodyButtons .CybotCookiebotDialogBodyButton:not(:last-of-type), #CybotCookiebotDialogFooter .CybotCookiebotDialogBodyButton, #CybotCookiebotDialogFooter .CybotCookiebotDialogBodyButton:not(:first-of-type) {
        margin-bottom: 8px !important;
        width: 100% !important;
        text-align: center !important;
        @media(min-width: 1024px){
            margin-bottom: 0 !important;
            width: 33% !important;
        }
    }

    #CybotCookiebotDialogBodyButtons .CybotCookiebotDialogBodyButton:not(:last-of-type), #CybotCookiebotDialogFooter .CybotCookiebotDialogBodyButton:not(:first-of-type) {
        flex-direction: column !important;
        @media(min-width: 1024px){
            flex-direction: row !important;
        }
    }

     #CybotCookiebotDialogBodyContentText, #CybotCookiebotDialogBodyContentText * {
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 20px !important;
    }

    #CybotCookiebotDialog #CybotCookiebotDialogBodyContentText a, #CybotCookiebotDialog #CybotCookiebotDialogBodyLevelButtonIABHeaderViewPartnersLink, #CybotCookiebotDialog #CybotCookiebotDialogDetailBulkConsentList dt a, #CybotCookiebotDialog #CybotCookiebotDialogDetailFooter a, #CybotCookiebotDialog .CybotCookiebotDialogBodyLevelButtonIABDescription a, #CybotCookiebotDialog .CybotCookiebotDialogDetailBodyContentCookieLink, #CybotCookiebotDialogDetailBodyContentTextAbout a, #CybotCookiebotDialog .CookieCard .CybotCookiebotDialogDetailBodyContentCookieContainerButton:hover, #CybotCookiebotDialog .CookieCard .CybotCookiebotDialogDetailBodyContentIABv2Tab:hover, #CybotCookiebotDialogDetailBodyContentCookieContainerTypes .CybotCookiebotDialogDetailBodyContentCookieProvider:not(.CybotCookiebotDialogDetailBodyContentCookieInfoCount):hover {
        color: ${theme.star.cookieBot.txtColoTertiary} !important;
    }

    #CybotCookiebotDialogNav .CybotCookiebotDialogNavItemLink:hover {
        color: ${theme.star.cookieBot.txtColoTertiary} !important;
    }

    #CybotCookiebotDialogTabContent .CybotCookiebotDialogDetailBulkConsentCount {
        background-color: ${theme.star.cookieBot.bgColorSeptenary} !important;
        color: ${theme.star.cookieBot.txtColorQuaternary} !important;
        font-size: 10px !important;
        font-weight: 700 !important;
        width: 20px !important;
        height: 20px !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        margin-left: 8px !important;
        letter-spacing: 0 !important;
    }

    /* SWITCH */
    #CybotCookiebotDialog .CybotCookiebotDialogBodyLevelButtonSlider {
        background-color: ${theme.star.cookieBot.bgColorSenary} !important;
        top: 50% !important;
        transform: translateY(-50%) !important;
    }

    #CybotCookiebotDialog .CybotCookiebotDialogBodyLevelButtonSlider:before {
       width: 20px !important;
       height: 20px !important;
       bottom: 2px !important;
       left: 2px !important;
       filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.15)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.15));
    }

    #CybotCookiebotDialog .CybotCookiebotDialogBodyLevelButtonSlider,  #CybotCookiebotDialog .CybotCookiebotDialogBodyLevelButton,  #CybotCookiebotDialog .CybotCookiebotDialogBodyLevelButtonSliderWrapper form {
        width: 44px !important;
        height: 24px !important;
    } 

    #CybotCookiebotDialog .CybotCookiebotDialogBodyLevelButtonSliderWrapper { 
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
    }

    #CybotCookiebotDialog input:checked+.CybotCookiebotDialogBodyLevelButtonSlider:before, #CybotCookiebotDialog[dir=rtl] #CybotCookiebotDialogTabContent input+.CybotCookiebotDialogBodyLevelButtonSlider:before {
        transform: translateX(20px) !important;
    }

    #CybotCookiebotDialogBodyLevelButtonsSelectPane label .CybotCookiebotDialogBodyLevelButtonDescription:hover {
        color: ${theme.star.cookieBot.bgColor} !important;
    }
    #CybotCookiebotDialog #CybotCookiebotDialogBodyLevelWrapper #CybotCookiebotDialogBodyLevelButtonsRow #CybotCookiebotDialogBodyLevelButtonsSelectPane form input[type="checkbox"][disabled]:checked + .CybotCookiebotDialogBodyLevelButtonSlider, #CybotCookiebotDialog form input[type="checkbox"][disabled]:checked + .CybotCookiebotDialogBodyLevelButtonSlider {
        opacity: 0.5 !important;
    }

    /* BUTTONS */
    #CybotCookiebotDialogFooter .CybotCookiebotDialogBodyButton {
        background-color: ${theme.star.cookieBot.bgColor} !important;
        border-color: ${theme.star.cookieBot.bgColor} !important;
        margin: 0 !important;
        flex: 1 !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        line-height: 20px !important;
        border-radius: ${theme.star.cookieBot.radiusSecondary} !important;
    }
    
    #CybotCookiebotDialog form input[type=checkbox]:not(:checked)+.CybotCookiebotDialogBodyLevelButtonSlider {
        background-color: ${theme.star.cookieBot.bgColorTertiary} !important;
    }

    #CybotCookiebotDialog input:checked+.CybotCookiebotDialogBodyLevelButtonSlider:before {
        box-shadow: 0px 0px 4px 0px ${theme.star.cookieBot.bgColorQuaternary};
    }

    #CybotCookiebotDialogBodyLevelButtonCustomize {
        order: 1;
    }

    #CybotCookiebotDialogBodyButtonDecline {
        order: 2;
    }

    #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll {
        order: 3;
    }

    /* BORDERS */
    #CybotCookiebotDialog #CybotCookiebotDialogBodyLevelButtonsSelectPane .CybotCookiebotDialogBodyLevelButtonWrapper:not(:last-of-type), #CybotCookiebotDialogBody .CybotCookiebotScrollContainer, #CybotCookiebotDialogNav {
        border-color: ${theme.star.cookieBot.bgColorQuinary} !important;
    }

    /* HIDE ELEMENTS */
    #CybotCookiebotDialog #CybotCookiebotDialogPoweredByText, #CybotCookiebotDialogHeader, .CookiebotWidget-main-logo { 
        display: none !important;
    }

    /* COOKIE BOT SETTINGS */
    /* WRAPPER */
    #CookiebotWidget strong {
        color: ${theme.star.cookieBot.txtColor} !important;
    }

    /* NAVIGATION */
    #CookiebotWidget-header *{
        color: ${theme.star.cookieBot.txtColor} !important;
    }

    #CookiebotWidget .CookiebotWidget-header .CookiebotWidget-close svg {
        fill: ${theme.star.cookieBot.txtColor} !important; 
    }

    #CookiebotWidget .CookiebotWidget-body .CookiebotWidget-consents-list li.CookiebotWidget-approved svg {
        fill: ${theme.star.cookieBot.txtColor} !important;
    }

    #CookiebotWidget .CookiebotWidget-consent-details button {
        color: ${theme.star.cookieBot.txtColor} !important;
    }

    #CookiebotWidget .CookiebotWidget-consent-details button svg {
        fill: ${theme.star.cookieBot.txtColor} !important;
    }

    /* DETAILS */
    #CookiebotWidget .CookiebotWidget-consent-details .CookiebotWidget-consent-details-box {
        background-color: ${theme.star.cookieBot.bgColorTertiary} !important;
    }
    
    #CookiebotWidget .CookiebotWidget-consent-details strong {
        color: ${theme.star.cookieBot.txtColor} !important;
    }

    #CookiebotWidget .CookiebotWidget-consent-details div {
        color: ${theme.star.cookieBot.txtColor} !important;
    }


    /* BUTTONS */
    #CookiebotWidget #CookiebotWidget-buttons #CookiebotWidget-btn-change {
        background-color: ${theme.star.cookieBot.bgColor} !important;
        border-color: ${theme.star.cookieBot.bgColor} !important;
        color: ${theme.star.cookieBot.txtColorSecondary} !important;
    }
    
    #CookiebotWidget #CookiebotWidget-buttons #CookiebotWidget-btn-withdraw {
        border: unset;
        background-color: ${theme.star.cookieBot.bgColorSecondary} !important;
        color: ${theme.star.cookieBot.txtColor} !important;
    }

    #CybotCookiebotDialogFooter .CybotCookiebotDialogBodyButton {
        color: ${theme.star.cookieBot.txtColorSecondary} !important;
    }

    #CybotCookiebotDialogBodyButtons .CybotCookiebotDialogBodyButton:not(#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll) {
        background-color: ${theme.star.cookieBot.bgColorSecondary} !important;
        border-color: transparent !important;
        color: ${theme.star.cookieBot.txtColor} !important;
    }

    #CybotCookiebotDialogFooter #CybotCookiebotDialogBodyLevelButtonCustomize .CybotCookiebotDialogArrow {
        display: none !important;
    }

    .CybotCookiebotDialogDetailBodyContentCookieContainerButton, .CybotCookiebotDialogDetailBodyContentCookieContainerButton label {
        font-size: 20px !important;
    }

    .CybotCookiebotDialogDetailBodyContentCookieContainerButton {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
    }

    .CybotCookiebotDialogDetailBodyContentCookieContainerButton:before {
        width: 14px !important;
        height: 14px !important;
        top: -3px !important;
        border-width: .1em .1em 0 0 !important;
        margin-right: 23px !important;
        transform: rotate(-225deg);
    }

    .CybotCookiebotDialogDetailBodyContentCookieContainerButton.CybotCookiebotDialogCollapsed:before {
        top: 0 !important;
        transform: rotate(45deg);
    }
    
    .CybotCookiebotDialogDetailBodyContentCookieTypeIntro {
        font-size: 14px !important;
        padding-top: 16px !important;
        padding-left: 39px !important;
    }

    #CybotCookiebotDialogBodyContentTitle {
        font-size: 20px !important;
        font-weight: 700 !important;
        line-height: 28px !important;
        margin-bottom: 4px !important;
    }

    .CybotCookiebotScrollContainer {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }

    #CybotCookiebotDialogBodyContent {
        padding-top: 24px !important;
        padding-bottom: 24px !important;
    }

    #CybotCookiebotDialogFooter .CybotCookiebotScrollArea {
        padding: 8px 16px 16px 16px !important;
    }

    .CybotCookiebotScrollContainer {
        border-bottom: none !important;
    }

    #CybotCookiebotDialogDetailBodyContentTextAbout, #CybotCookiebotDialogDetailBodyContentTextAbout *, #CybotCookiebotDialogDetailFooter, #CybotCookiebotDialogDetailFooter * {
        font-size: 14px !important;
        line-height: 20px !important;
    }

    #CybotCookiebotDialogBodyContent a, #CybotCookiebotDialogBodyContent a * {
        font-weight: 700 !important;
        text-decoration: underline !important;
     }
`;
